export const dataTicketPendientes = [
  {
    numero_ticket: "TCK-0001",
    operador_genera_ticket: "Juan Pérez",
    departamento_genera: "Soporte Técnico",
    operador_asignado: "María López",
    informacion_ticket: "Cliente reporta lentitud en el sistema",
    utltima_visita: "2025-01-10",
    tipo_servicio: "Soporte Remoto",
    nombre_cliente: "Empresa ABC",
    categoria: "Incidencia",
    observaciones: "Pendiente de validación",
    ciudad: "Quito",
    sector: "La Carolina",
    direccion: "Av. Amazonas y Naciones Unidas",
    coordenadas: "-0.1807,-78.4678",
    hora_asignacion: "10:30",
    ultimo_estado_proceso: "Pendiente de atención"
  },
  {
    numero_ticket: "TCK-0002",
    operador_genera_ticket: "Ana Torres",
    departamento_genera: "Ventas",
    operador_asignado: "Carlos Gómez",
    informacion_ticket: "Instalación de nuevo punto de red",
    utltima_visita: "2025-01-12",
    tipo_servicio: "Visita Técnica",
    nombre_cliente: "Comercial XYZ",
    categoria: "Solicitud",
    observaciones: "Requiere coordinación con el cliente",
    ciudad: "Guayaquil",
    sector: "Urdesa",
    direccion: "Av. Las Monjas",
    coordenadas: "-2.1709,-79.9224",
    hora_asignacion: "14:00",
    ultimo_estado_proceso: "Asignado"
  },
  {
    numero_ticket: "TCK-0003",
    operador_genera_ticket: "Luis Martínez",
    departamento_genera: "Atención al Cliente",
    operador_asignado: "Pedro Ramírez",
    informacion_ticket: "Error intermitente en facturación",
    utltima_visita: "2025-01-15",
    tipo_servicio: "Soporte Presencial",
    nombre_cliente: "Farmacias del Sur",
    categoria: "Error",
    observaciones: "Cliente solicita pronta solución",
    ciudad: "Cuenca",
    sector: "Centro Histórico",
    direccion: "Calle Larga",
    coordenadas: "-2.9005,-79.0045",
    hora_asignacion: "09:15",
    ultimo_estado_proceso: "En proceso"
  }
];
